import React from "react";
import SideBar from "../components/SideBar/SideBar";

function Home() {
  return (
    <div className="bg">
      <SideBar />
    </div>
  );
}

export default Home;
